import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { Button, Container } from '@material-ui/core';
import styles from './styles';
import useTranslation from '../../../hooks/useTranslation';

const SITE_LINK = process.env.REACT_APP_SHARE_ICON_LINK;

const EvidenceHub = (props) => {
  const { classes } = props;
  const { t } = useTranslation();

  return (
    <div className={classes.aboutUsContainer}>
      <Container maxWidth="lg">
        <Grid container spacing={0}>
          <Grid item xs={12} md={5} lg={4}>
            <div className={classes.aboutUsLeftBox}>
              <h3 className={classes.aboutUsHeading}>{t('evidenceHub')}</h3>
              <p className={classes.aboutUsText}>
                {t('evidenceHubTextDesc')}
              </p>
              <Button
                variant="outlined"
                className={classes.exploreButton}
                href={`${SITE_LINK}evidence-hub`}
              >
                {t('exploreEvidenceHub')}
                <i className="fas fa-arrow-right" style={{ marginLeft: '8px' }} />
              </Button>
            </div>
          </Grid>
          <Grid item xs={12} md={7} lg={8}>
            <div className={classes.aboutUsRightBox}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <ul className={classes.aboutUsList}>
                    <li><a href="https://developmentevidence.3ieimpact.org/" rel="noopener noreferrer">{t('dep')}</a></li>
                    <li><a href={`${SITE_LINK}impact/evidence-impact-summaries`} rel="noopener noreferrer">{t('eis')}</a></li>
                    <li><a href={`${SITE_LINK}resources/journal-of-development-effectiveness`} rel="noopener noreferrer">{t('jde')}</a></li>
                  </ul>
                </Grid>
                <Grid item xs={12} sm={6} className={classes.aboutUsRightCol}>
                  <ul className={classes.aboutUsList}>
                    <li><a href={`${SITE_LINK}evidence-hub/evidence-gap-maps`} rel="noopener noreferrer">{t('egm')}</a></li>
                    <li><a href={`${SITE_LINK}impact/impact-stories-dashboard`} rel="noopener noreferrer">{t('isd')}</a></li>
                    <li><a href={`${SITE_LINK}evidence-hub/publications`} rel="noopener noreferrer">{t('publications')}</a></li>
                  </ul>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

EvidenceHub.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EvidenceHub);
